import { useApplicantData } from './useApplicantData';
import { getApplicantData } from '../util/helpers/applicantDataHelper';
import useCountries from './useCountries';
import { findCountryByCode } from '../util/helpers/countries';

const useApplicationOwnerAddress = (applicantType) => {
  const ApplicantData = useApplicantData(applicantType);
  const AptOrSuite = getApplicantData(
    ApplicantData,
    'PersonAddress',
    'AptOrSuite',
  );
  const Apartment = getApplicantData(
    ApplicantData,
    'PersonAddress',
    'Apartment',
  );
  const Street = getApplicantData(ApplicantData, 'PersonAddress', 'Street');
  const City = getApplicantData(ApplicantData, 'PersonAddress', 'City');
  const State = getApplicantData(ApplicantData, 'PersonAddress', 'State');
  const PostalCode = getApplicantData(
    ApplicantData,
    'PersonAddress',
    'PostalCode',
  );
  const CountryIso3Code = getApplicantData(
    ApplicantData,
    'PersonAddress',
    'CountryIso3Code',
  );
  const countries = useCountries();
  let streetComponent = null;
  let cityComponent = null;
  let stateComponent = null;
  let postalComponent = null;

  if (AptOrSuite || Street) {
    streetComponent =
      AptOrSuite || Apartment
        ? `${AptOrSuite || Apartment} ${Street}, `
        : `${Street}, `;
  }
  if (City) {
    cityComponent = `${City}, `;
  }
  if (State) {
    stateComponent = `${State}, `;
  }
  if (PostalCode) {
    postalComponent = `${PostalCode}, `;
  }
  if (!CountryIso3Code) {
    return '';
  }
  return `${streetComponent}${cityComponent}${stateComponent}${postalComponent}${findCountryByCode(
    countries,
    CountryIso3Code,
  )}`;
};

export default useApplicationOwnerAddress;
